import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import validate from './validationUpdateDevice'
import DeviceUpdateDom from '../../../../../components/Screens/Estate/Store/Forms/DeviceUpdate'
import { ObjectUtils, EstateUtils, FormUtils } from '../../../../../utils'
import { Types as DeviceTypes } from '../../../../../actions/device'
import * as DeviceActions from '../../../../../actions/device'
import { Roles } from '../../../../../constants'
import initialState from './initialState'
import { filter } from 'lodash'

class DeviceUpdateForm extends PureComponent {
    static propTypes = {
        configs: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string.isRequired,
                value: PropTypes.shape({}).isRequired,
                created_at: PropTypes.string,
            })
        ),
        createDevice: PropTypes.func.isRequired,
        deviceUID: PropTypes.string,
        deviceUpdate: PropTypes.func.isRequired,
        fetchAvailableApks: PropTypes.func.isRequired,
        fetchDeviceGroups: PropTypes.func.isRequired,
        fetchDeviceStatus: PropTypes.func.isRequired,
        fetchDeviceTypes: PropTypes.func.isRequired,
        fetchSingleDevice: PropTypes.func.isRequired,
        fetchStoreLocations: PropTypes.func.isRequired,
        isAdmin: PropTypes.bool.isRequired,
        isDeviceStatusLoading: PropTypes.bool.isRequired,
        isOpen: PropTypes.bool,
        onClickCancel: PropTypes.func,
        reloadStore: PropTypes.func,
        selectedStore: PropTypes.shape({}),
        selectedDeviceStatus: PropTypes.shape({
            device: PropTypes.string,
            store_code: PropTypes.string,
            date: PropTypes.number,
            apk_version: PropTypes.string,
            hdmi: PropTypes.bool,
        }).isRequired,
        updateSettingsSocket: PropTypes.func,
    }

    static defaultProps = {
        isOpen: false,
        onClickCancel: () => null,
        deviceUID: null,
        reloadStore: () => null,
        selectedStore: null,
        configs: null,
        updateSettingsSocket: () => null,
    }

    constructor(props) {
        super(props)
        this.state = initialState
    }

    async componentDidUpdate(prevProps) {
        const { deviceUID, fetchAvailableApks, fetchDeviceGroups, fetchDeviceStatus, fetchDeviceTypes, fetchSingleDevice, fetchStoreLocations, isOpen } =
            this.props
        const { isOpen: wasOpen } = prevProps

        let availableChannels = []
        let apks = []
        let device = {}
        let storeLocations = []
        let deviceTypes = []
        let deviceGroups = []

        if (isOpen && isOpen !== wasOpen) {
            // Remove any previous error
            this.setState({
                formErrors: initialState.formErrors,
            })

            const responseAll = await Promise.all([
                fetchAvailableApks(),
                fetchStoreLocations(),
                fetchDeviceTypes(),
                fetchDeviceGroups(),
                deviceUID && fetchSingleDevice(deviceUID),
            ])

            if (deviceUID) {
                // No need to await
                fetchDeviceStatus(deviceUID)
            }

            const [responseApks, responseStoreLocations, responseDeviceTypes, responseDeviceGroups, responseDevice] = responseAll

            if (responseDevice && responseDevice.type === DeviceTypes.FETCH_SINGLE_DEVICE_SUCCESS) {
                const {
                    payload,
                    payload: {
                        channels,
                        store_location,
                        store_location: { id },
                    },
                } = responseDevice
                if (store_location && id) payload.store_location = id
                availableChannels = channels.map((channel) => {
                    const { slug } = channel
                    return {
                        ...channel,
                        value: slug,
                    }
                })
                device = {
                    ...payload,
                    four_k: payload['4k_resolution'] ?? false,
                } 
            }

            if (responseApks.type === DeviceTypes.FETCH_APK_SUCCESS) {
                const { payload } = responseApks
                apks = payload
                apks = apks.map((apk) => {
                    return {
                        ...apk,
                        value: apk,
                        name: apk,
                    }
                })
            }

            if (responseStoreLocations.type === DeviceTypes.FETCH_STORE_LOCATIONS_SUCCESS) {
                const { payload } = responseStoreLocations
                storeLocations = payload
                storeLocations = storeLocations.map((storeLocation) => {
                    const { id } = storeLocation
                    return {
                        ...storeLocation,
                        value: id.toString(),
                    }
                })
            }

            if (responseDeviceTypes.type === DeviceTypes.FETCH_DEVICE_TYPES_SUCCESS) {
                const { payload } = responseDeviceTypes
                deviceTypes = payload
                deviceTypes = deviceTypes.map((deviceType) => {
                    const { type } = deviceType
                    return {
                        ...deviceType,
                        value: type,
                    }
                })
            }

            if (responseDeviceGroups.type === DeviceTypes.FETCH_DEVICE_GROUPS_SUCCESS) {
                const { payload } = responseDeviceGroups
                deviceGroups = payload
                deviceGroups = deviceGroups.map((deviceGroup) => {
                    const { id } = deviceGroup
                    return {
                        ...deviceGroup,
                        value: id.toString(),
                    }
                })
            }

            // As we are comparing the actual props with the prevProps to avoid infinite loops, we can use setState inside componentDidUpdate
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(
                {
                    storeLocations,
                    apks,
                    deviceGroups,
                    deviceTypes,
                    channels: availableChannels,
                    fetchingData: false,
                },
                () => this.formatDeviceToForm(device)
            )
        }
    }

    isInConfig = (value, defaultValue) => {
        const { isInConfig } = FormUtils
        const { configs } = this.props
        const { formConfig } = this.state
        return isInConfig(formConfig, value, configs, defaultValue)
    }

    existInArray = (key, value, array, defaultValue) => {
        const { isInConfig, existInArray } = FormUtils
        const { configs } = this.props
        const { formConfig } = this.state
        const inArray = existInArray(value, array, '*default*')
        if (inArray !== '*default*') return inArray
        const valueToSearch = isInConfig(formConfig, key, configs, defaultValue)
        return valueToSearch
    }

    formatDeviceToForm = (device) => {
        const { selectedStore, deviceUID } = this.props
        const { channels, apks, storeLocations, deviceGroups, deviceTypes } = this.state
        let form = {}
        let defaultStoreCode = '00998'

        if (!deviceUID && selectedStore && selectedStore.code) {
            defaultStoreCode = selectedStore.code
        }


        if (device) {
            /**
             * Takes current value, or value from config if current not set, or default value, if not set in config
             * @param {String} key
             * @param {*} defValue
             * @param {Function} t Transformation function
             */
            const fromConfigOrDefault = (key, defValue, t = (v) => v) => t(device[key] ?? this.isInConfig(key, defValue))

            form = {

                api_url: device.api_url || this.isInConfig('api_url'),
                apk_version: this.existInArray('apk_version', device.apk_version, apks),
                background_colour: fromConfigOrDefault('background_colour'),
                cec_enabled: ['true', '1', 'enabled'].includes(String(fromConfigOrDefault('cec_enabled', 'false')).trim().toLowerCase()) ? 'true' : 'false',
                device_owner: fromConfigOrDefault('device_owner', 'true'),
                device_type: this.existInArray('device_type', device.device_type, deviceTypes, 'UNKNOWN'),
                antenna_level: device.antenna_level || '[4:3]',
                disable_zoom: device.disable_zoom ?? false,
                display_group: this.existInArray('display_group', device.display_group, deviceGroups, '1'),
                file_auth: fromConfigOrDefault('file_auth', 'true'),
                file_url: fromConfigOrDefault('file_url'),
                filter_level: device.filter_level ?? '20',
                four_k: device.four_k ?? false,
                id: device.id || '',
                layer_enabled: fromConfigOrDefault('layer_enabled', 'true'),
                layer_extra: fromConfigOrDefault('layer_extra', '{}', (v) => (typeof v === 'object' ? JSON.stringify(v) : v)),
                manufacturer: fromConfigOrDefault('manufacturer'),
                migrated_at: device.migrated_at || Date.now(),
                model: device.model,
                ntp_url: fromConfigOrDefault('ntp_url', 'time.google.com'),
                screen_rotation: fromConfigOrDefault('screen_rotation', 'Portrait'),
                selected_channel: this.existInArray('selected_channel', device.selected_channel, channels, 'none'),
                selected_type: fromConfigOrDefault('selected_type', 'PLAYLIST_TYPE_HD'),
                sku: fromConfigOrDefault('sku'),
                socket_url: fromConfigOrDefault('socket_url'),
                store_code: device.store_code || defaultStoreCode,
                store_location: this.existInArray('store_location', device.store_location, storeLocations, '1'),
                store_sync: fromConfigOrDefault('store_sync', 'true'),
                sync_delay: fromConfigOrDefault('sync_delay', '500'),
                sync_offset: fromConfigOrDefault('sync_offset', '0'),
                sync_timeout: fromConfigOrDefault('sync_timeout', '1000'),
                sync_url: fromConfigOrDefault('sync_url'),
                usb_serial: device.usb_serial,
                volume: device.volume || '0',
                working_close: fromConfigOrDefault('working_close', '2100'),
                working_open: fromConfigOrDefault('working_open', '0900'),
            }
        }

        this.setState({ device: form })
    }

    onChangeFormValue = ({ target: { name, value } }) => {
        const { device } = this.state
        const updated = { ...device }

        // Transform values and set them into the updated object
        switch (name) {
            case 'id': {
                const capitalized = value.toUpperCase().slice(0, 12)
                const mac = capitalized
                updated.id = capitalized

                // Group mac address pair of numbers
                if (mac.length && mac.length >= 2) {
                    updated.mac = mac.match(/.{1,2}/g).join(':')
                } else {
                    updated.mac = mac
                }
                break
            }
            case 'mac': {
                const capitalized = value.toUpperCase().slice(0, 17)
                const id = capitalized.replace(/:/g, '')
                updated.id = id
                updated.mac = (id.match(/.{1,2}/g) || []).join(':')
                break
            }
            default:
                updated[name] = value
        }

        this.setState({ device: updated }, this.forceUpdate())
    }

    onChangeAdvancedOptionsVisibility = () => {
        const { isOpenAdvancedOptions } = this.state
        this.setState({ isOpenAdvancedOptions: !isOpenAdvancedOptions })
    }

    onChangeServerOptionsVisibility = () => {
        const { isOpenServerOptions } = this.state
        this.setState({ isOpenServerOptions: !isOpenServerOptions })
    }

    onClickCancel = () => {
        const { onClickCancel } = this.props
        this.setState({ device: {} })
        onClickCancel()
    }

    buildOnchangeObject = () => {
        return {
            antenna_level: this.onChangeFormValue,
            api_url: this.onChangeFormValue,
            apk_version: this.onChangeFormValue,
            background_colour: this.onChangeFormValue,
            cec_enabled: this.onChangeFormValue,
            device_owner: this.onChangeFormValue,
            device_type: this.onChangeFormValue,
            disable_zoom: this.onChangeFormValue,
            display_group: this.onChangeFormValue,
            file_auth: this.onChangeFormValue,
            file_url: this.onChangeFormValue,
            filter_level: this.onChangeFormValue,
            four_k: this.onChangeFormValue,
            id: this.onChangeFormValue,
            layer_enabled: this.onChangeFormValue,
            layer_extra: this.onChangeFormValue,
            manufacturer: this.onChangeFormValue,
            migrated_at: this.onChangeFormValue,
            model: this.onChangeFormValue,
            ntp_url: this.onChangeFormValue,
            screen_rotation: this.onChangeFormValue,
            selected_channel: this.onChangeFormValue,
            selected_type: this.onChangeFormValue,
            sku: this.onChangeFormValue,
            socket_url: this.onChangeFormValue,
            store_code: this.onChangeFormValue,
            store_location: this.onChangeFormValue,
            store_sync: this.onChangeFormValue,
            sync_delay: this.onChangeFormValue,
            sync_offset: this.onChangeFormValue,
            sync_timeout: this.onChangeFormValue,
            sync_url: this.onChangeFormValue,
            usb_serial: this.onChangeFormValue,
            volume: this.onChangeFormValue,
            working_close: this.onChangeFormValue,
            working_open: this.onChangeFormValue,
        }
    }

    createUpdateDevice = async () => {
        const { deviceUpdate, deviceUID, reloadStore, createDevice } = this.props
        this.setState({ fetchingData: true })
        const { device, formErrors } = this.state
        let response = null

        if (deviceUID) {
            response = await deviceUpdate(device)
        } else {
            response = await createDevice(device)
        }

        const isCallSuccessful = [DeviceTypes.DEVICE_UPDATE_SUCCESS, DeviceTypes.CREATE_DEVICE_SUCCESS].includes(response?.type)

        if (isCallSuccessful) {
            reloadStore()
            this.onClickCancel()
        } else {
            const errorsMap = response?.payload?.response?.errors || {}
            const error = Object.values(errorsMap)[0]
            this.setState({
                fetchingData: false,
                formErrors: {
                    ...formErrors,
                    general: error,
                },
            })
        }
    }

    onClickPush = async () => {
        const { deviceUID, updateSettingsSocket } = this.props

        await updateSettingsSocket(deviceUID)
        this.onClickCancel()
    }

    onClickSubmit = () => {
        if (!this.validate()) {
            return
        }

        this.createUpdateDevice()
    }

    onClickSubmitAndPush = async () => {
        if (!this.validate()) {
            return
        }

        const { deviceUID, updateSettingsSocket } = this.props

        await this.createUpdateDevice()
        await updateSettingsSocket(deviceUID)
    }

    isExpanderWithErrors = () => {
        const { formErrors } = this.state
        const expanderServerOptions = ['api_url', 'socket_url', 'file_url', 'sync_url', 'ntp_url']
        const expanderAdvancedOptions = [
            'antenna_level',
            'apk_version',
            'background_colour',
            'device_owner',
            'disable_zoom',
            'four_k',
            'layer_enabled',
            'layer_extra',
            'migrated_at',
            'screen_rotation',
            'selected_channel',
            'selected_type',
            'store_sync',
            'sync_delay',
            'sync_offset',
            'sync_timeout',
            'usb_serial',
            'filter_level',
            'volume',
            'working_close',
            'working_open',
        ]
        let expanderAdvancedOptionsError = false

        expanderAdvancedOptions.forEach((element) => {
            if (formErrors[element]) expanderAdvancedOptionsError = true
        })

        let expanderServerOptionsError = false

        expanderServerOptions.forEach((element) => {
            if (formErrors[element]) expanderServerOptionsError = true
        })

        if (expanderAdvancedOptionsError) {
            this.setState({
                isOpenAdvancedOptions: true,
            })
        }

        if (expanderServerOptionsError) {
            this.setState({
                isOpenServerOptions: true,
            })
        }
    }

    /**
     * Form Validation
     */
    validate = () => {
        const { device } = this.state
        const formErrors = validate(device)
        this.setState({ formErrors }, this.isExpanderWithErrors)
        return ObjectUtils.isObjValuesEmpty(formErrors)
    }

    render() {
        const { isAdmin, isDeviceStatusLoading, isOpen, deviceUID, selectedDeviceStatus } = this.props
        const {
            apks,
            channels,
            device,
            deviceGroups,
            deviceTypes,
            fetchingData,
            formErrors,
            isOpenAdvancedOptions,
            isOpenServerOptions,
            storeLocations,
        } = this.state

        return (
            <DeviceUpdateDom
                ref={this.inputToFocus}
                apks={apks}
                channels={channels}
                device={device || null}
                deviceGroups={deviceGroups}
                deviceTypes={deviceTypes}
                deviceUID={deviceUID}
                errors={formErrors}
                fetchingData={fetchingData}
                isAdmin={isAdmin}
                isDeviceStatusLoading={isDeviceStatusLoading}
                isOpen={isOpen}
                isOpenAdvancedOptions={isOpenAdvancedOptions}
                isOpenServerOptions={isOpenServerOptions}
                onChangeAdvancedOptionsVisibility={this.onChangeAdvancedOptionsVisibility}
                onChangeForm={this.buildOnchangeObject()}
                onChangeServerOptionsVisibility={this.onChangeServerOptionsVisibility}
                onClickCancel={this.onClickCancel}
                onClickPush={this.onClickPush}
                onClickSubmit={this.onClickSubmit}
                onClickSubmitAndPush={this.onClickSubmitAndPush}
                selectedDeviceStatus={selectedDeviceStatus}
                storeLocations={storeLocations}
            />
        )
    }
}

function mapStateToProps(state) {
    const {
        device: { isWorking: isDeviceStatusLoading, selectedDeviceStatus },
        stores: { selectedStore },
        configs: { configs },
    } = state

    return {
        isDeviceStatusLoading,
        isAdmin: EstateUtils.hasPermission(state, {
            roles: [Roles.ROLE_ADMIN],
        }),
        selectedDeviceStatus,
        selectedStore,
        configs,
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...DeviceActions,
            fetchDeviceStatus: DeviceActions.fetchDeviceStatus,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(DeviceUpdateForm)
